import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgInboxFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.958 7.166h6.085a.75.75 0 0 1 0 1.5H8.958a.75.75 0 0 1 0-1.5m-1.669 4.572c1.179 0 2.238.658 2.762 1.718a2.16 2.16 0 0 0 1.948 1.214c.831 0 1.577-.465 1.946-1.213a3.07 3.07 0 0 1 2.763-1.72H21.3a.2.2 0 0 0 .2-.2V8.054c0-3.316-2.123-5.543-5.282-5.543H7.784C4.624 2.51 2.5 4.737 2.5 8.053v3.485c0 .11.09.2.2.2z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.709 13.238c-.605 0-1.149.338-1.42.884A3.65 3.65 0 0 1 12 16.17a3.65 3.65 0 0 1-3.293-2.05 1.57 1.57 0 0 0-1.418-.882H2.7a.2.2 0 0 0-.2.2v2.589c0 3.316 2.123 5.544 5.283 5.544h8.435c3.16 0 5.282-2.228 5.282-5.544v-2.59a.2.2 0 0 0-.2-.2z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgInboxFilled);
export default ForwardRef;
